export default function home_newsletter() {
	
  $("#newsletter-form").on("submit", function (e) {
    e.preventDefault();

    var data = $(this).serialize();
    $.ajax({
      type: "POST",
      url: "https://subs.sonymusicfans.com/submit",
      dataType: "json",
      data: data,
      xhrFields: {
        withCredentials: false
      },
      success: function (data) {
        $('.newsletter form').hide();
        $('.newsletter .newsletter-success').show();
      },
      error: function (err) {
        console.log(err);
        alert("An error has occurred!");
      }
    });
  });
	
}